module.exports = "/templates/bds/public/font/8270e503193150ebf94304681b327961.woff";